import * as React from "react";
import {
    reduxForm,
    Field,
    InjectedFormProps,
} from 'redux-form'
import {AppState} from "../../../../store/app_state";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";

import {Project} from "../../../../../domain/model/project";

import FormGroupRadioButtonConnectRf from "../../../../common/molecular/form_group/form_group_radio_button_connect_rf";
import styled from "styled-components";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import {ConstBorderRound, ConstColor} from "../../../../../config/styles_const/styles_const";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import BtnCancelSmall from "../../../../common/atom/btn/btn_cancel_small";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import ErrorText from "../../../../common/atom/text/error_text";

const validate = (values: any) => {
    const errors: any = {};

    return errors
};

interface IStateProps {
    initialValues: {} | undefined;
    formValues: any;
}

interface IProps extends IStateProps {
    projects: Project[];
    handlePreviousStep: (values: any) => void;
}

interface IState {
}

export class ClientScoutCustomerMainScoutSecondForm extends React.Component<IProps & InjectedFormProps<{}, IProps>, IState> {

    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);

        this.state = {};

    };

    public render(): JSX.Element {

        const {
            handleSubmit,
            pristine,
            error
        } = this.props;

        const {projects} = this.props;

        if (!projects) {
            return (<div/>)
        }

        let res: JSX.Element;

        // プロジェクト選択
        res = (
            <React.Fragment>
                <form
                    name="ClientScoutCustomerMainScoutForm-second"
                    onSubmit={handleSubmit}>

                    <Wrapper>
                        <Ul>
                            {projects.map((project: Project, index: number) => {
                                return (
                                    <li key={index}>
                                        <FormFieldWrapper>
                                            <Field
                                                name="projectId"
                                                component={FormGroupRadioButtonConnectRf}
                                                type="radio"
                                                value={`${project.id}`}
                                                label={`${project.name}`}
                                            />
                                        </FormFieldWrapper>
                                    </li>
                                )
                            })
                            }
                        </Ul>

                        {(error) && <SubmitErrorTextWrapper>
                            <ErrorText>{error}</ErrorText>
                        </SubmitErrorTextWrapper>}

                        <ButtonsWrapper>
                            <SubmitButtonWrapper>
                                <BtnCorporateLarge
                                    name="ClientScoutCustomerMainScoutForm-second-next"
                                    type="submit"
                                    widthSize={"200px"}
                                    disabled={pristine}>次へ</BtnCorporateLarge>
                            </SubmitButtonWrapper>
                            <CancelButtonWrapper>
                                <BtnCancelSmall
                                    type="button"
                                    onClick={this.props.handlePreviousStep}
                                >キャンセル</BtnCancelSmall>
                            </CancelButtonWrapper>
                        </ButtonsWrapper>
                    </Wrapper>
                </form>
            </React.Fragment>
        );

        return (res)
    };

}

const mapStateToProps = (state: AppState) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};

export default reduxForm({
        form: 'ClientScoutCustomerMainScoutForm',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate,
    }
)(connect(mapStateToProps, mapDispatchToProps)(ClientScoutCustomerMainScoutSecondForm));

const Ul = styled.ul`
     list-style: none;   
     margin-bottom: 40px; 
`;

const Wrapper = styled.div`
    padding: 40px;
    margin: 0 auto;
    max-width:  400px;
    border: 1px solid ${ConstColor.PlaceholderAndBorder};
    border-radius: ${ConstBorderRound.CornerRoundAll};
`;

const ButtonsWrapper = styled.div`
    text-align: center;   
`;

const SubmitButtonWrapper = styled.div`
    margin-bottom: 20px
`;

const CancelButtonWrapper = styled.div`
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customer/client_scout_customer_second/client_scout_customer_main_scout_second_form.tsx